<template>
  <div class="SFTemplateManage column-me">
    <div class="card-div">
      <div class="row-me row-center">
        <div class="width220">
          <el-input placeholder="模板名称" style="width: 100%;" clearable v-model="templateName"></el-input>
        </div>
        <div class="width220 margin-left10">
          <el-input placeholder="模板编码" style="width: 100%;" clearable v-model="templateCode"></el-input>
        </div>
        <div class="width220 margin-left10">
          <el-input placeholder="自定义模板编码" style="width: 100%;" clearable v-model="customCode"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
      </div>
      <div class="btn-blue width120 btn-height40 margin-top20" @click="clickAdd" v-if="canOperate">新增模板</div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="name" label="模板名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="templateCode" label="模板编码" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customTemplateCode" label="自定义模板编码" align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="模板属性" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{
                scope.row.attributesList.map(item => {
                  return item.key + item.value
                }).join('，')
              }}
            </template>
          </el-table-column>
          <el-table-column prop="describe" label="模板描述" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center" show-overflow-tooltip width="180">
            <template #default="scope">
              <div class="row-me center-all" v-if="canOperate">
                <div class="blue-text pointer" @click="clickEdit(scope.row)">编辑</div>
                <div class="red-text pointer margin-left30" @click="clickDelete(scope.row)">删除</div>
              </div>
              <div class="row-me center-all" v-else>
                <div class="blue-text pointer" @click="clickDetail(scope.row)">详情</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                       layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 新建模板弹窗 -->
    <el-dialog :title="templateTitle" v-model="visibleAdd" width="760px" top="10vh" :destroy-on-close="true">
      <div class="padding-right30">
        <div class="row-me row-center">
          <div class="left-title"><span class="red-star">*</span>模板名称：</div>
          <div class="flex1">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="addItem.name"
                      :disabled="!canOperate"></el-input>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-title"><span class="red-star">*</span>模板编码：</div>
          <div class="flex1 column-me">
            <div class="flex1 margin-bottom10">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="addItem.templateCode"
                        :disabled="!canOperate"></el-input>
            </div>
            <div class="tips-text">模板编码，关联云打印接口后，点击查看，可在接口详情页获取模板编码，类似：fm_76130_standard_{partnerId}，
              <span class="tips-text-blue" @click="clickTips(1)">查看模板编码位置</span></div>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-title">自定义模板编码：</div>
          <div class="flex1 column-me">
            <div class="flex1 margin-bottom10">
              <el-input placeholder="请输入" style="width: 100%;" clearable
                        v-model="addItem.customTemplateCode" :disabled="!canOperate"></el-input>
            </div>
            <div class="tips-text">自定义模板编码，当需要使用模板编辑器编辑自定义区域时，将自定义模板编码填写至该字段，
              <span class="tips-text-blue" @click="clickTips(2)">查看自定义模板编码位置</span></div>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-title">模板属性：</div>
          <div class="flex1 column-me">
            <div class="row-me row-center margin-bottom10" v-for="(item,index) in addItem.attributesList" :key="index">
              <div class="width150">
                <el-input placeholder="请输入属性名" style="width: 100%;" clearable v-model="item.key"
                          maxlength="100" :disabled="!canOperate"></el-input>
              </div>
              <div class="width160 margin-left10">
                <el-select placeholder="请选择属性值" style="width: 100%;" filterable clearable v-model="item.value"
                           :disabled="item.type===2||!canOperate">
                  <el-option v-for="item in propsValueArray" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="width130 margin-left10">
                <el-select placeholder="变量字段" style="width: 100%;" filterable :clearable="false" v-model="item.type"
                           @change="e=>typeChange(e,item)" :disabled="!canOperate">
                  <el-option v-for="item in typeArray" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <img src="../../assets/img/icon_jian.png" class="img35 objScaleDown pointer padding-left10"
                   @click="clickDeleteProps(index)" v-if="canOperate">
            </div>
            <div class="btn-blank-blue width100 btn-height32 margin-bottom10" @click="clickAddProps" v-if="canOperate">
              新增一行
            </div>
            <div class="tips-text">自定义模板时新增的字段，
              <span class="tips-text-blue" @click="clickTips(3)">查看新增字段位置</span></div>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-title">模板描述：</div>
          <div class="flex1">
            <el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable :disabled="!canOperate"
                      v-model="addItem.describe" autosize maxlength="500" show-word-limit></el-input>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top30">
          <div class="btn-blank width100 btn-height40" @click="visibleAdd=false">取消</div>
          <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSaveTemplate" v-if="canOperate">保存
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 预览图片 -->
    <el-dialog :title="title" v-model="visible" :width="width" top="5vh" :destroy-on-close="true">
      <preview-images :images="previewImages"></preview-images>
    </el-dialog>

  </div>
</template>

<script>
import previewImages from "../../components/previewImages.vue";

export default {
  components: {
    previewImages
  },
  data() {
    return {
      templateName: '',
      templateCode: '',
      customCode: '',
      tableData: [],
      pageNo: 1,
      total: 0,
      templateTitle: '',
      visibleAdd: false,
      addItem: {
        name: '',
        templateCode: '',
        customTemplateCode: '',
        attributesList: [{
          key: '',
          value: '',
          type: 1,//type:1变量字段，2固定值
        }],
        describe: '',
      },
      propsValueArray: [],//属性值集合
      typeArray: [{id: 1, name: '变量字段'}, {id: 2, name: '固定值'}],//1变量字段，2固定值
      visible: false,
      title: '',
      width: '50%',
      previewImages: [],
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.clickSearch()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    clickClear() {
      this.templateName = ''
      this.templateCode = ''
      this.customCode = ''
      this.clickSearch()
    },
    clickAdd() {
      this.templateTitle = '新增模板'
      this.addItem = {
        name: '',
        templateCode: '',
        customTemplateCode: '',
        attributesList: [{
          key: '',
          value: '',
          type: 1,//type:1变量字段，2固定值
        }],
        describe: '',
      }
      this.getPropsValue()
      this.visibleAdd = true
    },
    //编辑
    clickEdit(item) {
      this.templateTitle = '编辑模板'
      this.addItem = this.$method.deepClone(item)
      this.getPropsValue()
      this.visibleAdd = true
    },
    //查看模板
    clickDetail() {
      this.templateTitle = '查看模板'
      this.addItem = this.$method.deepClone(item)
      this.visibleAdd = true
    },
    //删除模板
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/sfExpress/modelDelete', {
          id: item.id
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //查看位置
    clickTips(index) {
      if (index === 1) {
        this.title = '查看模板编码位置'
        this.width = '1200px'
        this.previewImages = [
          {
            text: '请注册并登录顺丰开放平台(<a href="https://open.sf-express.com/" target="_blank" class="blue-text">https://open.sf-express.com/</a>),在业务中心-业务对接-开发者对接中找到创建的应用，步骤如下',
            img: require('../../assets/img/查看模板编码位置/图片1.png'),
          },
          {
            text: '',
            img: require('../../assets/img/查看模板编码位置/图片2.png'),
          },
          {
            text: '',
            img: require('../../assets/img/查看模板编码位置/图片3.png'),
          },
        ]
        this.visible = true
      } else if (index === 2) {
        this.title = '查看自定义模板编码位置'
        this.width = '1200px'
        this.previewImages = [
          {
            text: '2.1 请注册并登录顺丰开放平台(<a href="https://open.sf-express.com/" target="_blank" class="blue-text">https://open.sf-express.com/</a>),在业务中心-业务对接-开发者对接中找到创建的应用并查看云打印面单接口详情，在详情页面查找到自定义区入口，步骤如下',
            img: require('../../assets/img/自定义模板编码位置/图片4.png'),
          },
          {
            text: '2.2 找到已发布状态下的模板，将【模板编码】复制填入',
            img: require('../../assets/img/自定义模板编码位置/图片5.png'),
          },
        ]
        this.visible = true
      } else if (index === 3) {
        this.title = '查看新增字段位置'
        this.width = '1200px'
        this.previewImages = [
          {
            text: '3.1 请注册并登录顺丰开放平台(<a href="https://open.sf-express.com/" target="_blank" class="blue-text">https://open.sf-express.com/</a>),在业务中心-业务对接-开发者对接中找到创建的应用并找打已发布的打印模板，步骤如下',
            img: require('../../assets/img/新增字段位置/图片6.png'),
          },
          {
            text: '3.2 如果自定义字段是固定值类型，则将填写的固定值填入第一个属性名输入框即可，第二个属性值选择框不要填写',
            img: require('../../assets/img/新增字段位置/图片7.png'),
          },
          {
            text: '3.3 如果自定义字段是变量字段类型，则将填写的值填入第一个属性名输入框即可，第二个属性值选择框需要选择一个系统内定义的变量名与之对应',
            img: require('../../assets/img/新增字段位置/图片8.png'),
          },
        ]
        this.visible = true
      }
    },
    //获取数据
    getData() {
      this.$postFormRequest('/admin/sfExpress/modelPage', {
        name: this.templateName,
        templateCode: this.templateCode,
        customTemplateCode: this.customCode,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //新增模板属性
    clickAddProps() {
      this.addItem.attributesList.push({
        key: '',
        value: '',
        type: 1,
      })
    },
    //删除模板属性
    clickDeleteProps(index) {
      this.addItem.attributesList.splice(index, 1)
    },
    //变量字段改变
    typeChange(e, item) {
      if (item.type === 2) {//选了固定值，属性值需要清空禁用
        item.value = ''
      }
    },
    //获取属性值
    getPropsValue() {
      this.$getRequest('/admin/sfExpress/attributes', {}).then((res) => {
        if (res) {
          this.propsValueArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //保存模板
    clickSaveTemplate() {
      if (this.$method.isEmpty(this.addItem.name)) {
        this.$message.error('请输入模板名称')
        return
      }
      if (this.$method.isEmpty(this.addItem.templateCode)) {
        this.$message.error('请输入模板编码')
        return
      }
      if (!this.$method.isEmpty(this.addItem.customTemplateCode)) {
        if (this.addItem.attributesList.length === 0) {
          this.$message.error('请添加模板属性')
          return
        }
        for (let i = 0; i < this.addItem.attributesList.length; i++) {
          let item = this.addItem.attributesList[i]
          if (this.$method.isEmpty(item.type)) {
            this.$message.error('第' + (i + 1) + '行变量字段不能为空')
            return
          }
          if (item.type === 1) {//type:1变量字段，2固定值
            if (this.$method.isEmpty(item.key)) {
              this.$message.error('第' + (i + 1) + '行属性名不能为空')
              return
            }
            if (this.$method.isEmpty(item.value)) {
              this.$message.error('第' + (i + 1) + '行属性值不能为空')
              return
            }
          } else if (item.type === 2) {
            if (this.$method.isEmpty(item.key)) {
              this.$message.error('第' + (i + 1) + '行属性名不能为空')
              return
            }
          }
        }
      }
      let isInput = false;//模板属性是否输入了，输入了后自定义编码必填
      for (let item of this.addItem.attributesList) {
        if (!this.$method.isEmpty(item.key) || !this.$method.isEmpty(item.value)) {
          isInput = true
        }
      }
      if (isInput && this.$method.isEmpty(this.addItem.customTemplateCode)) {
        this.$message.error('请输入自定义模板编码')
        return
      }
      this.$postRequest('/admin/sfExpress/addModel', this.addItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleAdd = false
          this.clickSearch()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.SFTemplateManage {
  height: 100%;

  .card-div {
    height: 100%;
    margin: 20px;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    overflow: auto;
  }

  .left-title {
    width: 170px;
    text-align: right;
    margin-right: 10px;
  }

  .tips-text {
    font-size: 15px;
    color: #F19A38;
  }

  .tips-text-blue {
    color: #215AA0;
    cursor: pointer;

    &:hover {
      color: #459aff;
    }
  }
}
</style>
